export default function getPrevMenuState() {
    return {
        data: {
            menu: []
        }
    };
}



// WEBPACK FOOTER //
// ./src/Menu/Reducer/getPrevMenuState.js